export const findWeek = (referenceDate: Date) => {
  const start = new Date(referenceDate);
  start.setDate(referenceDate.getDate() - referenceDate.getDay());
  start.setHours(0);

  const end = new Date(start);
  end.setDate(start.getDate() + 6);
  end.setHours(23, 59, 59);

  return [start, end];
};

export const findMonth = (referenceDate: Date) => {
  const start = new Date(referenceDate);
  start.setDate(1);

  const end = new Date(referenceDate);
  end.setMonth(start.getMonth() + 1);
  end.setDate(0);
  return [start, end];
};

export const findYear = (refeceDate: Date) => {
  const start = new Date(refeceDate);
  start.setMonth(0);
  start.setDate(1);

  const end = new Date(refeceDate);
  end.setMonth(11);
  end.setDate(31);

  return [start, end];
};
